// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"08172e45","150":"f540d08e","229":"80b7cdd9"}[chunkId] + ".chunk.js";
};